import { useEffect, useState } from "react";
import { useApiClient } from "../../../hooks/useApiClient";
import { getEmployeeInfo } from "../../../services/employeesService";
import { IEmployeeInfoResponse } from "../Interfaces/IEmployeeInterface";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export function useEmployeeInfo(employeeId?: string) {
  const { call, ready } = useApiClient();
  const [data, setData] = useState<IEmployeeInfoResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!ready || !employeeId) return;

    (async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await call(getEmployeeInfo, employeeId);
        setData(res);
      } catch (err) {
        if (axios.isAxiosError(err)) {
          const status = err.response?.status;
          if (status === 403) {
            navigate("/forbidden", { replace: true });
            return;
          }
          if (status === 401) {
            navigate("/unauthorized", { replace: true });
            return;
          }
        }
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    })();
  }, [ready, employeeId, call, navigate]);

  return { data, loading, error };
}
